import React from "react";
import { UIButtonWithLoadingProgress } from "./UIComponents";
import UIModal from "./UIModal";

type UIDialogProps = {
	open: boolean;
	title: string | React.ReactNode;
	pageTitle?: string;
	getDescription?: () => string | React.ReactNode;
	confirmBtnTxt?: string | React.ReactNode;
	onConfirm: () => Promise<any>;
	onCancel: () => any;
	children?: React.ReactNode;
};

const UIConfirmDialog: React.FC<UIDialogProps> = (props) => {
	if (!props.open) return null;
	return (
		<UIModal
			title={props.title}
			pageTitle={props.pageTitle}
			open={props.open}
			onClose={() => props.onCancel()}
			showCloseIcon={true}
			noPadding={true}
			// className="wide-modal"
		>
			{!!props.getDescription && props.getDescription()}
			<div className="form-row d-flex justify-content-end mt-3">
				<button
					onClick={(e) => {
						e.preventDefault();
						props.onCancel();
					}}
					className="btn btn-link mr-2"
				>
					Cancel
				</button>
				<UIButtonWithLoadingProgress onClick={() => props.onConfirm()} className="btn btn-primary" autoFocus>
					{props.confirmBtnTxt || "Confirm"}
				</UIButtonWithLoadingProgress>
			</div>
		</UIModal>
	);
};

export default UIConfirmDialog;
